import { BaseComponent } from '../../base-component';
import { addEventMergeIdIfVariationChangedAndExists } from '../../_common/client/tracking';
import { BenefitData } from '../../_common/types/benefit';

export type PriceChangeEvent = {
    newPriceCents: number;
};

export class PriceComponent extends BaseComponent {
    public rootSelector = '.js_pdp_price';

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const variationId = this.getRootElement().dataset.variationId || '';
        this.registerOnFT9BenefitEvent();
        this.sendBenefitSlotReadyEvents(variationId);
        this.sendOttoUpTargetEvent(variationId);
    }

    private sendBenefitSlotReadyEvents(variationId: string): void {
        const targetElements = this.getChildElements('.js_pdp_price__benefit-target');
        const isSoldOut = this.getRootElement().dataset.isSoldOut === 'true';
        const productId = this.getRootElement().dataset.productId || '';

        if (isSoldOut) {
            return;
        }

        targetElements.forEach(targetElement => {
            const slotId = targetElement.dataset.slotId;
            o_global.eventQBus.emit(
                'ft9.benefit.slotReady',
                addEventMergeIdIfVariationChangedAndExists({
                    variationId,
                    productId,
                    targetElement,
                    slotId,
                })
            );
        });
    }

    private sendOttoUpTargetEvent(variationId: string): void {
        if (this.getRootElement().dataset.shouldShowUpInfoComponent !== 'true') {
            const targetElementBottom = this.getChildElement('.js_pdp_price__benefit-up-teaser-target-bottom');

            o_global.eventQBus.emit('ft9.up-teaser.variationChanged', {
                variationId,
                targetElement: targetElementBottom,
            });
        }
    }

    private registerOnFT9BenefitEvent(): void {
        o_global.eventQBus.on('ft9.benefit.active', (data: BenefitData) => {
            const benefitsElements = this.getChildElement('.pdp_price__inner').querySelectorAll<HTMLElement>('[data-benefit-id]');
            const priceElement = this.getChildElement('.js_pdp_price__price');
            const highlightedTextElement = document.querySelector('.js_pdp_price__discount-highlight');
            let hasActiveBenefits = false;

            benefitsElements.forEach(element => {
                const benefitId = element.dataset.benefitId;
                if (benefitId === data.id && data.active) {
                    element.classList.remove('pl_hidden');
                    priceElement.classList.add('pl_hidden');
                    highlightedTextElement?.classList.add('pdp_price__discount-highlight--sale');
                    this.removeInstallments(benefitId);
                    hasActiveBenefits = true;
                } else {
                    element.classList.add('pl_hidden');
                }
            });

            if (!hasActiveBenefits) {
                priceElement.classList.remove('pl_hidden');
            }

            this.notifyPriceChanged();
        });
    }

    private notifyPriceChanged(): void {
        const newPrice = this.getRootElement().querySelector<HTMLElement>('.js_pdp_price__tag:not(.pl_hidden)')?.dataset.priceCents;

        if (newPrice) {
            const event: PriceChangeEvent = {
                newPriceCents: Number(newPrice),
            };

            o_global.eventQBus.emit('ft5.variation.price.change', event);
        }
    }

    private removeInstallments(benefitId: string): void {
        const priceElem = document.querySelector<HTMLElement>(`.js_pdp_price__retail-price__value_${benefitId}`);
        if (priceElem && priceElem.innerHTML === '0,00&nbsp;€') {
            const installmentWrapper = document.querySelector('.js_pdp_price__installment-wrapper');
            installmentWrapper && installmentWrapper.classList.add('pl_hidden');
        }
    }
}
